import React, { useState, useEffect } from 'react';
import db from './database/db';
import LoginScreen from './components/LoginScreen';
import ProgressionScreen from './components/ProgressionScreen';
import TrainingScreen from './components/TrainingScreen';
import RecordsScreen from './components/RecordsScreen';
import HistoryScreen from './components/HistoryScreen';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [currentScreen, setCurrentScreen] = useState('progression');
  const [activeProgression, setActiveProgression] = useState(null);
  const [dbInitialized, setDbInitialized] = useState(false);

  useEffect(() => {
    initializeDatabase();
  }, []);

  useEffect(() => {
    if (user && dbInitialized) {
      loadActiveProgression();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, dbInitialized]);

  const initializeDatabase = async () => {
    try {
      await db.init();
      
      // Crear usuario admin si no existe
      const existingUser = await db.getUserByUsername('admin');
      if (!existingUser) {
        await db.createUser('admin', '1234'); // En producción usar hash
      }
      
      setDbInitialized(true);
    } catch (error) {
      console.error('Error initializing database:', error);
      alert('Error al inicializar la base de datos. Por favor, recarga la página.');
    }
  };

  const loadActiveProgression = async () => {
    if (!user) return;
    
    try {
      const progression = await db.getActiveProgression(user.id);
      setActiveProgression(progression);
    } catch (error) {
      console.error('Error loading active progression:', error);
    }
  };

  const handleLogin = async (userData) => {
    // Obtener el usuario real de la base de datos
    try {
      const dbUser = await db.getUserByUsername(userData.username);
      if (dbUser) {
        setUser({ id: dbUser.id, username: dbUser.username });
        setCurrentScreen('progression');
      } else {
        alert('Usuario no encontrado');
      }
    } catch (error) {
      console.error('Error during login:', error);
      alert('Error al iniciar sesión');
    }
  };

  const handleLogout = () => {
    setUser(null);
    setActiveProgression(null);
  };

  const handleProgressionUpdated = async () => {
    await loadActiveProgression();
  };

  const handleTrainingSaved = async () => {
    await loadActiveProgression();
  };

  if (!dbInitialized) {
    return (
      <div className="app">
        <div className="loading-screen">Inicializando base de datos...</div>
      </div>
    );
  }

  if (!user) {
    return <LoginScreen onLogin={handleLogin} />;
  }

  return (
    <div className="app">
      <nav className="app-nav">
        <button
          className={`nav-btn ${currentScreen === 'progression' ? 'active' : ''}`}
          onClick={() => setCurrentScreen('progression')}
        >
          Progresión
        </button>
        <button
          className={`nav-btn ${currentScreen === 'training' ? 'active' : ''}`}
          onClick={() => setCurrentScreen('training')}
        >
          Entrenar
        </button>
        <button
          className={`nav-btn ${currentScreen === 'records' ? 'active' : ''}`}
          onClick={() => setCurrentScreen('records')}
        >
          Records
        </button>
        <button
          className={`nav-btn ${currentScreen === 'history' ? 'active' : ''}`}
          onClick={() => setCurrentScreen('history')}
        >
          Historial
        </button>
        <button
          className="nav-btn nav-btn-logout"
          onClick={handleLogout}
          title="Cerrar sesión"
        >
          Salir
        </button>
      </nav>

      <main className="app-main">
        {currentScreen === 'progression' && (
          <ProgressionScreen
            userId={user.id}
            onProgressionUpdated={handleProgressionUpdated}
          />
        )}
        {currentScreen === 'training' && (
          <TrainingScreen
            userId={user.id}
            activeProgression={activeProgression}
            onTrainingSaved={handleTrainingSaved}
          />
        )}
        {currentScreen === 'records' && (
          <RecordsScreen userId={user.id} />
        )}
        {currentScreen === 'history' && (
          <HistoryScreen userId={user.id} />
        )}
      </main>
    </div>
  );
}

export default App;
